export default {
	InvoiceExport: {
		OrderNumber: 'No.',
		Accountant: 'Accountant',
		AccountingDate: 'Accounting  date',
		ActiveStatus: 'Supplier operating status',
		AmountOtherReduction: 'Other total deductions',
		SpecialItem: 'Special item',
		VehicleFrameNumber: 'Vehicle frame number',
		VehicleEngineNumber: 'Vehicle engine number',
		AssetType: 'Asset type',
		AssetCondition: 'Asset condition',
		Origin: 'Origin',
		SafetyQualityCertificateNumber: 'Safety and environmental certificate number',
		FactoryInspectionSerialNumber: 'Factory inspection serial number',
		ManufacturingCountryCode: 'Manufacturing country code',
		RegisteredAssetTypeName: 'Registered asset type name',
		ManufacturingYear: 'Manufacturing year',
		CommercialName: 'Commercial name',
		BrandName: 'Brand name',
		VehicleModel: 'Vehicle model',
		EngineDisplacementOrPower: 'Engine displacement or power',
		PayloadWeight: 'Payload weight',
		SeatingCapacity: 'Seating capacity',
		TransportLicensePlate: 'Transport license plate',
		DeparturePoint: 'Departure point',
		ArrivalPoint: 'Arrival point',
		TransportedGoodsName: 'Transported goods name',
		ShipperName: 'Shipper name',
		ShipperAddress: 'Shipper address',
		ShipperTaxCode: 'Shipper tax code',
		ShipperIdentifier: 'Shipper identifier',
		LandParcelInfo: 'Land parcel info',
		AttachedToLandAssetInfo: 'Asset attached to land',
		AmountReductionNotTax: 'Total deduction is not taxable',
		BranchName: 'Branch name',
		BranchTax: 'Branch tax',
		BuyerAddress: 'Buyer address',
		BuyerFullName: 'Buyer full name',
		BuyerTaxCode: 'Buyer tax code',
		BuyerInvRevEmail: 'Invoice Receive Email',
		BuyerName: 'Buyer name',
		CcyCode: 'Currency',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		CompanyName: 'Company name',
		CompanyTax: 'Company tax code',
		CreatedDate: 'System entry date',
		DepartmentName: 'Department name',
		ExchangeRate: 'Exchange rate',
		Explain: 'Explain',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signed date',
		InvoiceNo: 'Invoice No.',
		IssueDate: 'Code issuance date',
		TaxReduction: 'Tax reduction',
		ItemName: 'Name of goods and services',
		LicensePlate: 'License plate',
		LinkSearch: 'Link search',
		Noted: 'Note',
		CostNorms: 'Cost norms',
		BeyondTheNorm: 'Beyond the norm',
		NotificationWrong: 'Notification wrong',
		Quantity: 'Quantity',
		RefNo: 'Ref No.',
		SearchCode: 'Search code',
		SellerAddress: 'Seller address',
		SellerName: 'Seller name',
		SellerTaxCode: 'Seller Tax Code',
		SellerBankAccount: 'Seller Bank Account',
		PaymentMethod: 'Payment Method',
		SellerTaxCode1: 'Seller tax code',
		Series: 'Series',
		SheetName: 'General_list_purchased_goods_services',
		StickName: 'Stick',
		SupplierCode: 'Unit code',
		TemplateNo: 'Form No.',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		TotalAmountWithoutVat: 'Total amount without vat',
		TotalAmountWithoutVatDisplay: 'Merchandise total amount',
		TotalDiscountAmount: 'Discount amount',
		TotalHasDiscount: 'Total amount without tax',
		TotalHasDiscountCC: 'Converted ex-tax sales revenue',
		TotalVATAmount: 'VAT amount',
		TotalVATAmountCC: 'VAT amount exchange',
		TotalFeesAmountXML: 'Total fees amount',
		UnitName: 'Unit name',
		UnitPrice: 'Unit price',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice xml',
		VatAmount: 'Total vat amount',
		VatRate: 'VAT rate',
		Status: 'Status',
		CostType: 'Cost type',
		StatusInvoice: 'Status invoice',
		// tổng hợp
		BuyerFullName: 'Buyer',
		Explain: 'Explain',
		TotalAmountWithoutVatDisplay: 'Total purchase amount',
		RelativeInvoice: 'Related invoice',
		StickName: 'Sticker',
		AmountReductionNotTax: 'Total deduction is not taxable',
		// chi tiết
		BatchNo: 'Lot No.',
		ExpiredDate: 'Expired date',
		NatureText: 'Nature',
		UnitName: 'Unit',
		Quantity: 'Quantity',
		UnitPrice: 'Unit price',
		SearchCode: 'Search code',
		LinkSearch: 'Link search'
	},
	DeclarationExport: {
		OrderNumber: 'No.',
		DeclarationNo: 'Declaration no.',
		DeclarationDate: 'Declaration date',
		CreatedDate: 'Created date',
		InvoiceNo: 'Invoice No.',
		VatTaxableValue: 'Taxable value for VAT',
		ExporterName: 'Exporter name',
		BuyerAddress: 'Buyer address',
		TotalDeclarationAmount: 'Total declaration amount',
		TotalDeclarationAmountExchange: 'Total declaration amount exchange',
		TotalPreCustomsFee: 'Total precustoms fee',
		TotalPreCustomsFeeExchange: 'Total precustoms fee exchange',
		TotalTaxValue: 'Total tax value',
		TotalTaxAmount: 'Total tax amount',
		TotalPaymentAmountExchange: 'Total payment amount exchange',
		CcyCode: 'Currency',
		ExchangeRate: 'Exchange rate',
		CompanyName: 'Company name',
		CompanyTax: 'Company tax',
		BranchName: 'Branch name',
		BranchTax: 'Branch tax',
		DepartmentName: 'Department name',
		InventoryCode: 'Inventory code',
		InvetoryItemName: 'Invetory item name',
		UnitName: 'Unit name',
		Quantity: 'Quantity',
		UnitPrice: 'Unit price',
		Amount: 'Amount',
		AmountExchange: 'Amount exchange',
		InvCustomsFeeExchange: 'Inv customs fee exchange',
		TaxPrice: 'Taxable value',
		ImportTax: 'Import tax',
		ImportTaxAmount: 'Import tax amount',
		TaxDumpingDetail: 'Anti-dumping tax',
		TaxDumpingDetailAmount: 'Anti-dumping amount',
		TTDBTax: 'Special consumption tax',
		TTDBTaxAmount: 'Special consumption tax amount',
		TaxEnvDetailAmount: 'Environmental tax amount',
		VatTax: 'Vat tax',
		VatTaxAmount: 'Vat tax amount',
		TotalItemTaxAmount: 'Total item tax amount',
		AmountAfterTax: 'Amount after tax'
	},
	InvoiceExportThirdParty: {
		OrderNumber: 'No.',
		Accountant: 'Accountant',
		AccountingDate: 'Accounting  date',
		ActiveStatus: 'Supplier operating status',
		AmountOtherReduction: 'Other total deductions',
		SpecialItem: 'Special item',
		VehicleFrameNumber: 'Vehicle frame number',
		VehicleEngineNumber: 'Vehicle engine number',
		AssetType: 'Asset type',
		AssetCondition: 'Asset condition',
		Origin: 'Origin',
		SafetyQualityCertificateNumber: 'Safety and environmental certificate number',
		FactoryInspectionSerialNumber: 'Factory inspection serial number',
		ManufacturingCountryCode: 'Manufacturing country code',
		RegisteredAssetTypeName: 'Registered asset type name',
		ManufacturingYear: 'Manufacturing year',
		CommercialName: 'Commercial name',
		BrandName: 'Brand name',
		VehicleModel: 'Vehicle model',
		EngineDisplacementOrPower: 'Engine displacement or power',
		PayloadWeight: 'Payload weight',
		SeatingCapacity: 'Seating capacity',
		TransportLicensePlate: 'Transport license plate',
		DeparturePoint: 'Departure point',
		ArrivalPoint: 'Arrival point',
		TransportedGoodsName: 'Transported goods name',
		ShipperName: 'Shipper name',
		ShipperAddress: 'Shipper address',
		ShipperTaxCode: 'Shipper tax code',
		ShipperIdentifier: 'Shipper identifier',
		LandParcelInfo: 'Land parcel info',
		AttachedToLandAssetInfo: 'Asset attached to land',
		AmountReductionNotTax: 'Total deduction is not taxable',
		BranchName: 'Branch name',
		BranchTax: 'Branch tax',
		BuyerAddress: 'Buyer address',
		BuyerFullName: 'Buyer full name',
		BuyerTaxCode: 'Buyer tax code',
		BuyerInvRevEmail: 'Invoice Receive Email',
		BuyerName: 'Buyer name',
		CcyCode: 'Currency',
		ChangeStatusInvoiceDate: 'Change status invoice on Tax Authority date',
		ChangeStatusInvoiceOnSystemDate: 'Status change detection date',
		CompanyName: 'Company name',
		CompanyTax: 'Company tax code',
		CreatedDate: 'System entry date',
		DepartmentName: 'Department name',
		ExchangeRate: 'Exchange rate',
		Explain: 'Explain',
		InvoiceDate: 'Invoice date',
		SignedDate: 'Signed date',
		InvoiceNo: 'Invoice No.',
		IssueDate: 'Code issuance date',
		TaxReduction: 'Tax reduction',
		ItemName: 'Name of goods and services',
		LicensePlate: 'License plate',
		LinkSearch: 'Link search',
		Noted: 'Note',
		CostNorms: 'Cost norms',
		BeyondTheNorm: 'Beyond the norm',
		NotificationWrong: 'Notification wrong',
		Quantity: 'Quantity',
		RefNo: 'Ref No.',
		SearchCode: 'Search code',
		SellerAddress: 'Seller address',
		SellerName: 'Seller name',
		SellerTaxCode: 'Seller Tax Code',
		SellerBankAccount: 'Seller Bank Account',
		PaymentMethod: 'Payment Method',
		SellerTaxCode1: 'Seller tax code',
		Series: 'Series',
		SheetName: 'General_list_purchased_goods_services',
		StickName: 'Stick',
		SupplierCode: 'Unit code',
		TemplateNo: 'Form No.',
		TotalAmount: 'Total amount',
		TotalAmountExchange: 'Total amount exchange',
		TotalAmountWithoutVat: 'Total amount without vat',
		TotalAmountWithoutVatDisplay: 'Merchandise total amount',
		TotalDiscountAmount: 'Discount amount',
		TotalHasDiscount: 'Total amount without tax',
		TotalHasDiscountCC: 'Converted ex-tax sales revenue',
		TotalVATAmount: 'VAT amount',
		TotalVATAmountCC: 'VAT amount exchange',
		TotalFeesAmountXML: 'Total fees amount',
		UnitName: 'Unit name',
		UnitPrice: 'Unit price',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice xml',
		VatAmount: 'Total vat amount',
		VatRate: 'VAT rate',
		Status: 'Status',
		CostType: 'Cost type',
		StatusInvoice: 'Status invoice',
		// tổng hợp
		BuyerFullName: 'Buyer',
		Explain: 'Explain',
		TotalAmountWithoutVatDisplay: 'Total purchase amount',
		RelativeInvoice: 'Related invoice',
		StickName: 'Sticker',
		AmountReductionNotTax: 'Total deduction is not taxable',
		// chi tiết
		BatchNo: 'Lot No.',
		ExpiredDate: 'Expired date',
		NatureText: 'Nature',
		UnitName: 'Unit',
		Quantity: 'Quantity',
		UnitPrice: 'Unit price',
		SearchCode: 'Search code',
		LinkSearch: 'Link search'
	}
};
